module.exports = "<p>Drum Kit</p>\n<button class=\"beat-box-btn\" type=\"button\" (click)=\"setBeatBox()\" name=\"button\">A</button>\n<button class=\"lo-fi-btn\" type=\"button\" (click)=\"setLoFi()\" name=\"button\">B</button>\n<button class=\"808-btn\" type=\"button\" (click)=\"set808()\" name=\"button\">C</button>\n"


//////////////////
// WEBPACK FOOTER
// /Users/BREA/Desktop/drum-machine/src/app/change-kit/change-kit.component.html
// module id = ../../../../../src/app/change-kit/change-kit.component.html
// module chunks = main